<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-04-29 13:38:16
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-05-08 17:15:40
 * @FilePath: \my_build\src\views\paper\components\QuesType.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <el-button @click.stop="getList" class="submit-btn2"> 选择订单 </el-button>
    <el-dialog
      title="选择订单"
      :visible.sync="show"
      calss="width1190"
      append-to-body
    >
      <el-form
        :model="queryParams"
        ref="queryForm"
        inline
        size="small"
        class="my-search-box"
      >
        <el-form-item prop="Title">
          <el-input
            v-model="queryParams.Title"
            placeholder="搜索商品名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="TypeID">
          <el-select
            v-model="queryParams.TypeID"
            placeholder="订单类型"
            clearable
            @change="getList"
          >
            <el-option
              v-for="(it, i) in statusOptions"
              :key="i"
              :label="it.label"
              :value="it.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getList" class="search-btn"> 搜索 </el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="tableData"
        stripe
        border
        class="lb-table"
        @selection-change="handleSelectionChange"
      >
        <el-table-column width="40" type="selection" />
        <el-table-column
          prop="OrdersNo"
          label="订单编号"
          align="center"
          min-width="200"
        />
        <el-table-column
          prop="RelatedTypeTxt"
          label="订单类型"
          align="center"
          width="120"
        />
        <el-table-column
          prop="RelatedName"
          label="商品名称"
          align="center"
          min-width="200"
        />
        <el-table-column
          prop="PayedAmount"
          label="实付金额（元）"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <span class="Amount b600">{{
              scope.row.PayedAmount ? scope.row.PayedAmount : ""
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="AddTime"
          label="下单时间"
          align="center"
          width="180"
        />
      </el-table>

      <!-- <Pagination v-show="total > 0" :total="total" :page-sizes="[5, 10, 20]" :page.sync="PageIndex" :limit.sync="PageSize" @pagination="getList" /> -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="submit" class="submit-btn">确定</el-button>
        <!-- <el-button
          type="primary"
          style="
            width: 86px;
            height: 36px;
            background: #ffffff;
            border-radius: 4px;
            border: 1px solid #2f5aff;
            line-height: 2px;
            color: #2f5aff;
          "
          @click="cancel"
          >取消</el-button
        > -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { GetMyInvoiceSelectOrders } from "@/api/member";
export default {
  name: "QuesType",
  props: {},
  data() {
    return {
      show: false,
      queryParams: {
        Title: "",
        TypeID: "",
      },
      statusOptions: [
        { label: "课程", value: 1 },
        { label: "资料", value: 2 },
        { label: "练习", value: 3 },
        { label: "报名", value: 4 },
      ],
      tableData: [],
      selectedList: [],
    };
  },

  created() {},
  methods: {
    getList() {
      this.selectedList = [];
      const data = {
        ...this.queryParams,
      };
      GetMyInvoiceSelectOrders(data).then((res) => {
        if (res.code == 0) {
          this.show = true;
          this.tableData = res.data;
        }
      });
    },
    submit() {
      if (this.selectedList.length == 0) {
        this.$message({
          message: "请选择订单",
          type: "warning",
        });
        return false;
      }
      this.$emit("selectedList", this.selectedList);
      this.cancel();
    },
    cancel() {
      this.show = false;
    },
    handleSelectionChange(val) {
      this.selectedList = val;
    },
  },
};
</script>

<style scoped lang="scss">
.Amount {
  font-weight: bold;
  font-size: 20px;
  color: #e12a14;
}
.submit-btn {
  width: 144px;
  height: 52px;
  background: #1d79ff;
  border-radius: 6px;
  font-size: 18px;
  color: #ffffff;
}
.submit-btn2 {
  width: 98px;
  height: 46px;
  padding: 0;
  background: #1d79ff;
  border-radius: 6px;
  font-size: 16px;
  color: #ffffff;
}
.width1190 {
  ::v-deep .el-dialog {
    width: 1190px;
  }
}
::v-deep .el-input__inner {
  width: 201px;
  height: 47px;
  background: #f6f8fc;
  border-radius: 23px;
  border: 1px solid #e6e6e6;
}
</style>
